import { gql, QueryHookOptions, QueryResult, useQuery } from '@apollo/client'
import { ID } from '../../utils/id'
import { COMPANY_FRAGMENT, CompanyFragment } from '../fragment/company.fragment'

interface Data {
  company: CompanyFragment
}

interface Variables {
  id: ID
}

const QUERY = gql`
  query getCompany($id: ID!) {
    company: getCompanyById(id: $id) {
      ...Company
    }
  }

  ${COMPANY_FRAGMENT}
`

export const useCompanyQuery = (
  options: QueryHookOptions<Data, Variables>,
): QueryResult<Data, Variables> => useQuery<Data, Variables>(QUERY, options)
